module.exports = __webpack_public_path__ + "static/media/byanca.eea5a3ae.jpg";